module.exports = __webpack_public_path__ + "static/media/title-sc.33008940.png";